
import template from './services.html'

class ServicesPageViewModel
{
	constructor (page)
	{   
		this.page = page;
		this.type_service = ko.observable();
		this.types_services = ko.observableArray([]);
		this.type = ko.observableArray([]);
		this.service = ko.observable();
		this.settings = ko.observableArray([]);

		this.type_service.subscribe	(async (type_service) => {
			if(!type_service)
				return;
			
			this.split_type_service(type_service);

			let data = await this.get_service_settings();			
			this.settings(data);
		});
	}  
	
	async btn_save_service_setting() 
	{
		let save = this.save_service_setting();
		if(save.status == 'ERROR')
			Grape.alerts.alert({type: 'error', title: 'Error', message: 'Error while saving settings'});
	
		Grape.alerts.alert({type: 'success', title: 'Saved', message: 'The service settings have been saved'});
	}
	
	async btn_create_service()
	{
		let dialog = await Grape.dialog.open('AddEditService', {});
		
		await this.page.load_all_services();
		if(dialog.status == 'OK')
			this.type_service(`${dialog.type_name}_${dialog.service_name}`);

	}

	async get_service_settings()
	{
		let result = await Grape.fetches.getJSON('/api/services/setting', {service_name: this.service(), type_name: this.type()});
		if(result.status == 'ERROR')
			return;

		let settings = result.settings.map(setting => {
			return {
				name: setting.name,
				value: ko.observable(setting.value),
				masked: setting?.masked,
				show: ko.observable(false)
			};
    	});	

		return settings;
	}

	btn_show(data)
	{
		if(!data)
			return;
		
		if(data.show())
			data.show(false);
		else
			data.show(true)
	}

	async save_service_setting() 
	{
		let data = this.serialize_settings();
		let type = this.type();
		let service = this.service();
		
		if(!type || !service)
		{
			Grape.alerts.alert({type: 'error', title: 'Error', message: 'Error while saving settings'});
			return;
		}

		let result = await Grape.fetches.postJSON('/api/services', {service_name: service, type_name: type, settings: data});
		return result;
	}

	serialize_settings()
	{
		return ko.toJS(this.settings());
	}

	split_type_service(merged)
	{
		if (!merged)
			return;

		let index = merged.indexOf("_");

		this.type(merged.substring(0, index));
		this.service(merged.substring(index + 1));
	}
}

class ServicesPage
{
	constructor (bindings)
	{
		this.viewModel = new ServicesPageViewModel(this);
		this.bindings = bindings;
	}
	
	async init ()
	{
		document.title = 'Dashboard - Services';
		await this.load_all_services();
	}

	async load_all_services()
	{
		let data = await Grape.fetches.getJSON('/api/record', {
			schema: 'server',
			table: 'v_services'
		});

		if(data.status == 'ERROR')
			return;
		
		let data_merge = this.merge_types_services(data.records);

		this.viewModel.types_services(data_merge);
	}
	
	merge_types_services(services)
	{
		if (!Array.isArray(services))
			return [];

		return services.map(service => {

			let service_name_heading = service.service_name.split('_')
				.map(x => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase())
				.join(' ');
			
			return {
				type_service: `${service.type_name}_${service.service_name}`,
				type_name: service.type_name,
				service_name: service.service_name,
				display: `${service_name_heading} (${service.type_name})`
			};
		});
	}
}

export default {
	route: '[/]ui/services',
	page_class: ServicesPage,
	template: template,
	name: 'services',
	title: 'Services',
	page_id: 'ps_dashboard.services',
	icon: 'fa-regular fa-screwdriver-wrench',
	idx: 3
}

